<template>
  <div class="paas-split">
    <Split v-model="split" :min="siderWidth" v-height="{offsetHeight:100}">
      <div slot="left" class="paas-split-pane"  ref="treeWrap">
        <wrapper-tree
          title="文章分类"
          ref="wrapperTree"
          icon = "ios-construct-outline"
          offsetHeight = 70
          :serviceUrl="serviceUrl"
          :currentIdFiledName="currentIdFiledName"
          :start-tree-node="startTreeCode"
          tree-node-icon="iconfont iconpaixing"
          @getKeyChange="updateTimeKey"
          @on-node-click="paasNodeClick">
        </wrapper-tree>
      </div>
      <router-view :key="key" slot="right" class="paas-split-pane" @getKeyChange="updateTimeKey"  :paasTreeParentName="parentName">
      </router-view>
    </Split>
  </div>
</template>

<script>
  import wrapperTree from '@components/paas/wrapper-tree'
  export default {
    name: "frame",
    components:{wrapperTree},
    data(){
      return{
        serviceUrl:"/eb/article/category", //后台访问路径，必须
        currentIdFiledName:"id",
        parentName:'',
        siderWidth:"250px",  //sider的宽度，必须是number类型的
        treeHeight:'', //树的高度
        startTreeCode:'',  //起始树节点,只传paasLikeTreeCode的值 '100'、'101'等等
        key:'' ,//route-view更新
        split:0.25  //面板位置，可以是 0~1 代表百分比，或具体数值的像素，可用 v-model 双向绑定
      }
    },
    created() {

    },
    mounted(){

    },
    methods:{
      updateTimeKey(){
        this.key = new Date().getTime();
      },
      /**
       * 添加根节点
       */
      paasAddRoot(event, url) {
        if(!url) {
          url = this.serviceUrl+"/edit?parentId=root";
        }
        this.updateTimeKey();
        this.$router.push({'path':this.setUrlFuncId(url)});
      },
      /**
       * url添加功能ID参数,封装这个方法是以防功能配置也有传参数
       * */
      setUrlFuncId(url) {
        if(url.indexOf("?") !== -1) {
          url += '&';
        } else {
          url += '?';
        }
        //组装paasCurrentFunctionId=***
        url += this.$store.state.funcIdName+'='+this.$route.query[this.$store.state.funcIdName];
        return url;
      },
      /**
       * 点击节点渲染右侧列表数据
       * @param node
       */
      paasNodeClick(node){
        let url = "";
        if(node.id){
          url += this.serviceUrl+"/list?"+this.currentIdFiledName+"="+node.id;
        }
        this.parentName = node.title;
        this.updateTimeKey();
        this.$router.push({'path':this.setUrlFuncId(url)});
      }
    }
  }
</script>

<style scoped>
  .paas-split{
    padding:10px;
  }
  .paas-split >>> .wrapper{
    padding:0px;
  }
  .paas-split-pane,.paas-split >>> .paas-split-pane{
    padding-left:5px;
  }
</style>
